import './custom_highchart.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.CustomCrossDimensionsChart extends Monitoring.Views.Charts.CustomHighchart
  url: '/monitoring/api/charts/cross_dimension'
  className: 'processing item custom-chart w2'
  defaultSize: 'w2'

  events:
    'click #close_chart': 'destroy'

  initialize: (@options = {}) ->
    super(@options)
    if @._settings.dimension == 'time'
      if @facets['date']
        @initialTime = @facets['date'].min
        @finalTime = @facets['date'].max
      @calculateInterval()

  series: ->
    @showPercentage = !!@_settings.showPercentage
    @showValue = !!@_settings.showValue
    series = @data.series
    series = @orderSeries(series)
    for serie in series
      serie.type = @_settings.type
      serie.events = {
        click: @_previewSearch unless @_settings.avoid_preview
        legendItemClick: @legendItemClickEvent
      }
      if (serie.code + "").indexOf('missing') > -1
        serie.name = "No #{@_translateName @options.settings.crossDimensionTitle || @options.settings.crossDimension}"
      for data in serie.data
        if (data.code + "").indexOf('missing') > -1
          data.name = "No #{@_translateName @options.settings.chartDimensionTitle || @options.settings.dimension}"
      serie.color = @customColors()[serie.code]
      serie.visible = @getVisibilityFor(serie.name)
    series

  customOptions: ->
    that = @
    {
    plotOptions:
      column:
        stacking: @_settings.stacking
        dataLabels:
          enabled: true
          inside: true
          color: '#000000'
          style:
            textShadow: '0 none'
          formatter: ->
            text = ''
            text += if that.showPercentage && this.percentage then this.percentage.toFixed(2) + "%" else ""
            text += if that.showPercentage && this.percentage && that.showValue then " - " else ""
            text += if that.showValue then "#{this.y}" else ""
            return if this.y then text else null
    xAxis:
      type: if @._settings.dimension == 'time' then 'datetime' else 'category'
      labels:
        formatter: ->
          if that.interval == '1M'
            Highcharts.dateFormat('%B', @value)
          else if that.interval == '1w'
            sixDays = 86400 * 6 * 1000
            lowerBoundLabel = Highcharts.dateFormat('%d. %b', @value)
            upperBoundLabel = if @value + sixDays > Date.now() then 'now' else Highcharts.dateFormat('%d. %b', @value + sixDays)
            "#{lowerBoundLabel} - #{upperBoundLabel}"
          else if that.interval == 60*24
            Highcharts.dateFormat('%d. %b', @value)
          else if that.interval == 60
            Highcharts.dateFormat('%H:%M', @value)
          else
            @axis.defaultLabelFormatter.call(@)
    yAxis:
      title:
        text: null
    legend:
      verticalAlign: 'bottom'
      align: 'center'
      layout: 'horizontal'
      borderWidth: 0
      margin: 6
      maxHeight: 60
      borderWidth: 0
    tooltip:
      followPointer: true
      positioner: (labelWidth, labelHeight, point) ->
        chart = this.chart
        pointX = if (point.plotX + labelWidth > chart.plotWidth) then point.plotX + chart.plotLeft - labelWidth - 10 else point.plotX + chart.plotLeft + 10
        x = if pointX > 0 then pointX else 0
        y = if point.plotY + chart.plotTop - 20 > 35 then point.plotY + chart.plotTop - 20 else 35
        return { x: x , y: y }
      useHTML: true,
      formatter: ->
        if @percentage
          '<table><tr><td style="text-align: center;">' + @percentage.toFixed() + '%</td></tr><tr><td style="text-align: center;">' + "#{@series.name}: #{@y}" + '</td></tr></table>'
        else
          "#{@series.name}: #{@y}"
    }

  getNewQuery: (event) ->
    query = @searchQuery.deepCopy()
    if @_settings.dimension == 'time'
      query.addDateFrom(event.point.x)
      if @interval == '1M'
        from = new Date(event.point.x)
        to = new Date(from)
        to.setMonth(from.getMonth() + 1)
        query.addDateTo(to.valueOf())
      else if @interval == '1w'
        query.addDateTo(event.point.x + 60*24*7 * 60000)
      else
        query.addDateTo(event.point.x + @interval * 60000)
      query.removeDateFromRealtime()
    else
      @_setDimension(query, @_settings.dimension, @getValueForDimension(@_settings.dimension, event.point))
    @_setDimension(query, @_settings.crossDimension, @getValueForDimension(@_settings.crossDimension, event.point.series.options))
    query

  getSearchQuery: ->
    query = @searchQuery.deepCopy()
    query.set('first_dimension', @_settings.dimension)
    query.set('second_dimension', @_settings.crossDimension)
    if @_settings.dimension == 'time'
      query.set('interval', @interval)
    query

  getAjaxData: ->
    _.extend({}, super, {effective_date_bounds: {from: @effectiveDateFrom(), to: @effectiveDateTo()}})

  effectiveDateFrom: ->
    (@facets['date'] || {}).min

  effectiveDateTo: ->
    (@facets['date'] || {}).max

  calculateInterval: ->
    per_month = {text: I18n.t('monitoring.dashboard.charts.export_options.month'), onclick: @onClick('1M') }
    per_week = {text: I18n.t('monitoring.dashboard.charts.export_options.week'), onclick: @onClick('1w') }
    per_day = {text: I18n.t('monitoring.dashboard.charts.export_options.day'), onclick: @onClick(60*24) }
    per_hour = {text: I18n.t('monitoring.dashboard.charts.export_options.hour'), onclick: @onClick(60) }

    dateFilterLength = (@finalTime - @initialTime) / 60000

    if dateFilterLength <= 60*24 # 1 day
      @exportingOptions = [per_month, per_week, per_day, per_hour]
      @interval = 60 # 1 hour
    else if dateFilterLength <= 60*24*30 # 30 days
      @exportingOptions = [per_month, per_week, per_day]
      @interval = 60*24 # 1 day
    else if dateFilterLength <= 60*24*120 # 120 days
      @exportingOptions = [per_month, per_week]
      @interval = '1w'
    else
      @exportingOptions = [per_month]
      @interval = '1M'

  onClick: (interval) ->
    =>
      @interval = interval
      @data = null
      @afterAppend()

  chartOptions: ->
    options = super()
    toggleDisplay = [{
      text: if @showValue then I18n.t('monitoring.dashboard.charts.hide_value_labels') else I18n.t('monitoring.dashboard.charts.show_value_labels')
      onclick: (() => @toggleDisplayValue())
    },{
      text: if @showPercentage then I18n.t('monitoring.dashboard.charts.hide_percentage_labels') else I18n.t('monitoring.dashboard.charts.show_percentage_labels')
      onclick: (() => @toggleDisplayPercentage())
    }]
    options.exporting.buttons.contextButton.menuItems = options.exporting.buttons.contextButton.menuItems.concat(toggleDisplay)
    options

  toggleDisplayValue: =>
    @showValue =  !@showValue
    @_settings.showValue =  @showValue
    @chart = new Highcharts.Chart(@chartOptions())
    @applyChartZoom()
    @trigger('chartsChange')

  toggleDisplayPercentage: =>
    @showPercentage =  !@showPercentage
    @_settings.showPercentage =  @showPercentage
    @chart = new Highcharts.Chart(@chartOptions())
    @applyChartZoom()
    @trigger('chartsChange')

  maximizedOptions: ->
    plotOptions:
      column:
        showInLegend: false
        dataLabels:
          enabled: true
          inside: true
          color: '#000000'
          style:
            textShadow: '0 0 3px white'
          formatter: @labelFormatter

  labelFormatter: ->
    if @point.y == 0
      ""
    else
      "#{@series.name}: #{@point.y}"
